module.exports = {
  "zones": {
    "Antarctica/Troll": ["z", {
      "wallclock": 1108166400000,
      "format": "%s",
      "abbrev": "+00",
      "offset": 0,
      "posix": 1108166400000,
      "save": 0,
      "rules": "Troll"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "-00",
      "abbrev": "-00",
      "offset": 0,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Troll": [{
      "from": 2005,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 120,
      "letter": "+02",
      "saved": 0
    }, {
      "from": 2004,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "+00",
      "saved": 7200000
    }]
  }
};